import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Row,
  Col,
  Dropdown,
  Button,
  Form,
  Modal
} from "react-bootstrap";
import CommonTable from '../components/CommonTable/CommonTable';
import '../tasks/tasklist.css';
import {
  FiFile,
  FiFileText,
  FiImage,
  FiSearch,
  FiDownload,
  FiMoreVertical,
  FiClock,
  FiFolder,
  FiX,
  FiUpload,
  FiFolderPlus,
  FiRefreshCw,
  FiShare2,
  FiPlus,
  FiTrash2,
  FiChevronLeft,
  FiChevronRight
} from 'react-icons/fi';
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileArchive,
  FaFileAlt,
  FaFolder
} from 'react-icons/fa';
import './documentDrive.css';
import './commonstyle.css';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import { formatDateTimeToDDMMMYYYY, formatDateToDDMMMYYYY } from '../../utils/dateFormatter';
import { buildDocumentSharePayload } from '../../utils/documentSharePayload';
import DocumentUploadForm from './DocumentUploadForm';
import DocumentShareForm from './DocumentShareForm';
import ShareDocumentModal from './ShareDocumentModal';
import axiosInstance from '../../services/AxiosInstance';
import { useDocumentAccess } from '../../hooks/useDocumentAccess';
import CategorizationIcon from './CategorizationIcon';

const DocumentsDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasAccess, loading: accessLoading } = useDocumentAccess();

  // Static data for recent files - sorted by most recently accessed
  const [recentFiles, setRecentFiles] = useState([]);

  // Static folders data
  const [staticFolders, setStaticFolders] = useState([]);

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [folderName, setFolderName] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  // Classification creation form state
  const [classificationFormData, setClassificationFormData] = useState({
    name: '',
    parent_id: null,
    fields: [{ id: Date.now(), fieldName: '', fieldType: '0' }]
  });
  const [availableClassificationsForParent, setAvailableClassificationsForParent] = useState([]);
  const [classificationFormErrors, setClassificationFormErrors] = useState({});
  const [loadingClassificationsForParent, setLoadingClassificationsForParent] = useState(false);
  const [prefillParentId, setPrefillParentId] = useState(null);
  const [documentClassifications, setDocumentClassifications] = useState([]);
  const [classificationsLoading, setClassificationsLoading] = useState(false);
  const [dynamicFields, setDynamicFields] = useState({});
  // File access fields
  const [isPrivate, setIsPrivate] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedSubDepartments, setSelectedSubDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [filteredSubDepartments, setFilteredSubDepartments] = useState([]);
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  const [checkingDuplicates, setCheckingDuplicates] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateChoices, setDuplicateChoices] = useState({}); // { fileName: 'replace' | 'copy' }
  const [documentSuggestions, setDocumentSuggestions] = useState([]);
  const [newButtonHovered, setNewButtonHovered] = useState(false);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [suggestionsError, setSuggestionsError] = useState(null);
  const suggestionsScrollRef = useRef(null);
  // Search state
  const [dashboardSearchQuery, setDashboardSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // Share form state
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareSelectedItem, setShareSelectedItem] = useState(null);
  const [shareSelectedBranches, setShareSelectedBranches] = useState([]);
  const [shareSelectedDepartments, setShareSelectedDepartments] = useState([]);
  const [shareSelectedSubDepartments, setShareSelectedSubDepartments] = useState([]);
  const [shareSelectedUsers, setShareSelectedUsers] = useState([]);
  const [shareFilteredDepartments, setShareFilteredDepartments] = useState([]);
  const [shareFilteredSubDepartments, setShareFilteredSubDepartments] = useState([]);
  const [shareFilteredUsers, setShareFilteredUsers] = useState([]);
  const [shareAvailableUsers, setShareAvailableUsers] = useState([]);
  const [sharing, setSharing] = useState(false);

  const notifySuccess = (msg) => toast.success(`✔️ ${msg}`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });

  const notifyError = (msg) => toast.error(`❌ ${msg}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

  // Handle dropdown toggle to check position
  const handleDropdownToggle = (isOpen, event) => {
    if (!isOpen) return; // Only handle when opening

    // Use setTimeout to ensure DOM is ready
    setTimeout(() => {
      try {
        // Find the currently open dropdown menu - check both container classes
        const visibleDropdowns = document.querySelectorAll('.document-section .dropdown-menu.show, .document-drive-container .dropdown-menu.show');

        if (visibleDropdowns.length === 0) {
          return; // No open dropdown found
        }

        // Get the most recently opened dropdown (last one in the list)
        const dropdownMenu = visibleDropdowns[visibleDropdowns.length - 1];
        const dropdown = dropdownMenu.closest('.dropdown');

        if (!dropdown) {
          return;
        }

        // Find the toggle button
        const toggleElement = dropdown.querySelector('.dropdown-toggle');

        if (!toggleElement) {
          return; // Can't determine position without toggle element
        }

        const rect = toggleElement.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;

        // Estimate dropdown menu height (typically 150-200px for 3-4 items)
        // Get actual menu height if available for more accurate detection
        let estimatedDropdownHeight = 180;
        if (dropdownMenu.offsetHeight > 0) {
          estimatedDropdownHeight = dropdownMenu.offsetHeight;
        } else {
          // Estimate based on number of items (roughly 40-50px per item)
          const itemCount = dropdownMenu.querySelectorAll('.dropdown-item').length;
          estimatedDropdownHeight = Math.max(itemCount * 45, 150);
        }

        // Be VERY conservative - only open above if there's clearly not enough space below
        // and significantly more space above
        const minSpaceBelow = estimatedDropdownHeight + 50; // Need at least 230px below
        const minSpaceAbove = estimatedDropdownHeight + 20; // Need at least 200px above

        // Only open above if:
        // 1. There's definitely not enough space below (less than minSpaceBelow)
        // 2. AND there's significantly more space above (at least 80px more - very conservative)
        // 3. AND there's enough space above to fit the menu
        const shouldOpenAbove = spaceBelow < minSpaceBelow &&
          spaceAbove > (spaceBelow + 80) &&
          spaceAbove >= minSpaceAbove;

        // Add/remove dropup class
        // Add class to card and column to allow dropdown overflow
        const driveItem = dropdown.closest('.drive-item');
        const driveItemCol = dropdown.closest('.drive-item-col');
        if (driveItem) driveItem.classList.add('dropdown-open');
        if (driveItemCol) driveItemCol.classList.add('dropdown-open');

        if (shouldOpenAbove) {
          dropdown.classList.add('dropup');
          // Check if menu gets cut off after Bootstrap positions it
          setTimeout(() => {
            const menuRect = dropdownMenu.getBoundingClientRect();
            if (menuRect.top < 0) {
              dropdownMenu.style.maxHeight = `${Math.max(spaceAbove - 5, 120)}px`;
              dropdownMenu.style.overflowY = 'auto';
            }
          }, 50);
        } else {
          dropdown.classList.remove('dropup');
          dropdownMenu.style.maxHeight = '';
          dropdownMenu.style.overflowY = '';
        }

        // Remove the class when dropdown closes
        const removeOverflowClass = () => {
          if (driveItem) driveItem.classList.remove('dropdown-open');
          if (driveItemCol) driveItemCol.classList.remove('dropdown-open');
        };
        dropdown.addEventListener('hidden.bs.dropdown', removeOverflowClass, { once: true });
      } catch (error) {
        console.error('Error in handleDropdownToggle:', error);
      }
    }, 10); // Small delay to ensure DOM is updated
  };

  useEffect(() => {
    loadRecentDocuments();
    loadDocumentSuggestions();
    loadDocumentClassifications();
    fetchBranches();
    fetchDepartments();
    fetchSubDepartments();
    fetchShareUsers();
  }, []);

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // Bootstrap md breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Fetch users for share form
  const fetchShareUsers = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      if (!corporateId) return;

      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));

      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];

      const filteredUsers = users.filter(user => user.id !== userData.id);

      setShareAvailableUsers(filteredUsers);
      setShareFilteredUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Initialize share form filters when departments/sub-departments are loaded
  useEffect(() => {
    if (departments.length > 0) {
      setShareFilteredDepartments(departments);
    }
    if (subDepartments.length > 0) {
      setShareFilteredSubDepartments(subDepartments);
    }
  }, [departments, subDepartments]);

  useEffect(() => {
    let filtered = [...recentFiles];

    // Filter by file type
    if (filterType !== 'all') {
      filtered = filtered.filter(file => {
        const fileExt = file.name?.split('.').pop()?.toLowerCase() || '';
        const typeMap = {
          'pdf': ['pdf'],
          'word': ['doc', 'docx'],
          'excel': ['xls', 'xlsx'],
          'powerpoint': ['ppt', 'pptx'],
          'image': ['jpg', 'jpeg', 'png', 'gif'],
          'other': []
        };
        return typeMap[filterType]?.includes(fileExt);
      });
    }

    // Filter by search term
    if (searchTerm.trim()) {
      filtered = filtered.filter(file =>
        file.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        file.folder_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredFiles(filtered);
  }, [searchTerm, filterType, recentFiles]);

  const formatDocumentItem = (item) => {
    if (!item) {
      return null;
    }

    if (item.document) {
      const formatted = formatDocumentItem(item.document);
      if (!formatted) {
        return null;
      }

      return {
        ...formatted,
        reason: item.reason || item.document_reason || formatted.reason
      };
    }

    const normalizedType = item.type || item.item_type || (item.is_folder ? 'folder' : 'file');

    if (normalizedType === 'file') {
      const fileName = item.name || item.file_name || '';
      const fileExt = item.file_type?.toLowerCase() || fileName.split('.').pop()?.toLowerCase() || '';

      const fileTypeMap = {
        'pdf': 'pdf',
        'doc': 'word',
        'docx': 'word',
        'xls': 'excel',
        'xlsx': 'excel',
        'ppt': 'powerpoint',
        'pptx': 'powerpoint',
        'jpg': 'image',
        'jpeg': 'image',
        'png': 'image',
        'gif': 'image'
      };

      return {
        id: item.id,
        name: fileName,
        file_name: fileName,
        type: 'file',
        folder_id: item.document_path_id || item.folder_id,
        folder_name: item.folder?.name || item.folder_name || 'My Documents',
        size: item.file_size ? `${(parseFloat(item.file_size) / 1024 / 1024).toFixed(2)} MB` : item.size || '0 MB',
        last_accessed: item.last_accessed || item.updated_at || item.created_at,
        last_modified: item.last_modified || item.updated_at || item.created_at,
        file_type: fileTypeMap[fileExt] || item.file_type || 'file',
        category_id: item.category?.id || item.category_id || null,
        category_name: item.category?.name || item.category_name || null,
        is_private: item.is_private,
        version: item.version || null,
        reason: item.reason || item.description || null,
        document_title: item.document_title || null,
        registered_to: item.registered_to || null,
        reference_number: item.reference_number || null,
        issue_date: item.issue_date || null,
        expiry_date: item.expiry_date || null,
        remind_before: item.remind_before || null,
        issuing_authority: item.issuing_authority || null,
        other_comments: item.other_comments || null,
        uploaded_by: item?.uploaded_by_user?.full_name || null,
        created_at: item.created_at || null,
        updated_at: item.updated_at || null,
      };
    }

    if (normalizedType === 'folder') {
      return {
        id: item.id,
        name: item.name,
        type: 'folder',
        parent_id: item.parent_id,
        folder_name: item.parent?.name ? `${item.parent.name} / ${item.name}` : (item.folder_name || item.name),
        last_accessed: item.last_accessed || item.updated_at || item.created_at,
        last_modified: item.last_modified || item.updated_at || item.created_at,
        file_type: 'folder',
        uploaded_by: item?.uploaded_by_user?.full_name || null,
        created_at: item.created_at || null,
        category_name: item.parent?.name || null,
        category_id: item.parent?.id || item.connection_id || null,
      };
    }

    return null;
  };

  const loadRecentDocuments = async () => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      // Build query parameters
      const params = new URLSearchParams();
      params.append('corporate_id', corporateId);
      params.append('limit', '20'); // Default limit

      const response = await axiosInstance.get(`/documents/recent?${params.toString()}`);
      const data = response.data;

      if (response.status === 200 && data.success) {
        const responseData = data.data;
        const items = responseData.items || [];

        // Format items to match expected structure
        const formattedItems = items
          .map(formatDocumentItem)
          .filter(Boolean);

        setRecentFiles(formattedItems);
      }
    } catch (error) {
      console.error('Error fetching recent documents:', error);
      notifyError(error.response?.data?.message || 'Failed to load recent documents');
      // Keep existing data on error
    } finally {
      setLoading(false);
    }
  };

  const loadDocumentSuggestions = async () => {
    setSuggestionsLoading(true);
    setSuggestionsError(null);

    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      const response = await axiosInstance.get('/documents/suggested', {
        params: {
          corporate_id: corporateId,
          limit: 8
        }
      });

      if (response.status === 200) {
        const responseData = response.data;
        const payload = responseData.data.documents;
        const items = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.items)
            ? payload.items
            : [];

        const formattedItems = items
          .map(formatDocumentItem)
          .filter(Boolean);

        setDocumentSuggestions(formattedItems);
      }
    } catch (error) {
      console.error('Error fetching document suggestions:', error);
      setSuggestionsError(error.response?.data?.message || 'Failed to load suggestions');
    } finally {
      setSuggestionsLoading(false);
    }
  };

  const loadDocumentClassifications = async () => {
    setClassificationsLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      const response = await axiosInstance.get(`/document-categories?corporate_id=${corporateId}`);
      const data = response.data;

      if (response.status === 200) {
        // Handle response structure: { success: true, data: [...] }
        const classifications = data.success ? data.data : (data.data || data || []);
        setDocumentClassifications(classifications);
      }
    } catch (error) {
      console.error("Error fetching document classifications:", error);
      notifyError('Failed to fetch document classifications');
      // Fallback to static classifications on error
      const staticCats = [
        { id: 1, name: 'General' },
        { id: 2, name: 'Contracts' },
        { id: 3, name: 'Reports' },
        { id: 4, name: 'Invoices' },
        { id: 5, name: 'Legal' },
        { id: 6, name: 'Financial' },
        { id: 7, name: 'HR Documents' },
        { id: 8, name: 'Project Documents' }
      ];
      setDocumentClassifications(staticCats);
    } finally {
      setClassificationsLoading(false);
    }
  };

  const formatClassificationItem = (classification) => {
    if (!classification) {
      return null;
    }

    return {
      id: classification.id,
      name: classification.name,
      type: 'folder',
      parent_id: classification.parent_id || null,
      folder_name: classification.parent_id ? `${classification.name}` : classification.name,
      last_accessed: classification.updated_at || classification.created_at,
      last_modified: classification.updated_at || classification.created_at,
      file_type: 'folder',
      uploaded_by: classification.created_by?.full_name || null,
      created_at: classification.created_at || null,
      category_name: classification.name,
      category_id: classification.id,
    };
  };

  const performSearch = useCallback(async (query) => {
    if (!query || !query.trim()) {
      setSearchResults([]);
      setSearchError(null);
      return;
    }

    setSearchLoading(true);
    setSearchError(null);

    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      const response = await axiosInstance.get('/documents/search', {
        params: {
          corporate_id: corporateId,
          search: query.trim()
        }
      });

      if (response.status === 200) {
        const responseData = response.data;
        let allItems = [];

        // Extract documents
        if (responseData.data?.documents && Array.isArray(responseData.data.documents)) {
          const formattedDocuments = responseData.data.documents
            .map(formatDocumentItem)
            .filter(Boolean);
          allItems = [...allItems, ...formattedDocuments];
        }

        // Extract classifications
        if (responseData.data?.classifications && Array.isArray(responseData.data.classifications)) {
          const formattedClassifications = responseData.data.classifications
            .map(formatClassificationItem)
            .filter(Boolean);
          allItems = [...allItems, ...formattedClassifications];
        }

        setSearchResults(allItems);
      }
    } catch (error) {
      console.error('Error searching documents:', error);
      setSearchError(error.response?.data?.message || 'Failed to search documents');
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  }, []);

  // Debounced search effect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (dashboardSearchQuery.trim()) {
        performSearch(dashboardSearchQuery);
      } else {
        setSearchResults([]);
        setSearchError(null);
      }
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [dashboardSearchQuery, performSearch]);

  const fetchBranches = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      const res = await axiosInstance.get(`/settings/branches?corporate_id=${corporateId}`);
      const data = res.data;

      if (res) {
        setBranches(data.data || data || []);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
      const data = res.data;

      if (res) {
        const deptList = data.data || data || [];
        setDepartments(deptList);
        setFilteredDepartments(deptList);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const fetchSubDepartments = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      let res;
      try {
        res = await axiosInstance.get(`/settings/subDepartments?corporate_id=${corporateId}`);
      } catch (e1) {
        res = await axiosInstance.get(`/settings/subdepartments?corporate_id=${corporateId}`);
      }
      const data = res.data;

      if (res) {
        const subDeptList = data.data || data || [];
        setSubDepartments(subDeptList);
        setFilteredSubDepartments(subDeptList);
      }
    } catch (error) {
      console.error('Error fetching sub-departments:', error);
    }
  };

  // Handle branch change - filter departments
  const handleBranchChange = (branchIds, selectedOptions) => {
    setSelectedBranches(branchIds);

    if (branchIds.length > 0) {
      // Filter departments based on selected branches
      const filtered = departments.filter(dept => branchIds.includes(dept.branch_id));
      setFilteredDepartments(filtered);

      // Keep only valid departments
      const validDepartmentIds = selectedDepartments.filter(deptId => {
        return filtered.some(d => d.id === deptId);
      });
      setSelectedDepartments(validDepartmentIds);

      // Filter sub-departments based on valid departments
      const subs = subDepartments.filter(sd => validDepartmentIds.includes(sd.department_id));
      setFilteredSubDepartments(subs);

      // Keep only valid sub-departments
      const validSubDepartmentIds = selectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => (sd.id || sd.sub_department_id) === subDeptId);
      });
      setSelectedSubDepartments(validSubDepartmentIds);
    } else {
      // Reset to all departments and sub-departments
      setFilteredDepartments(departments);
      setFilteredSubDepartments(subDepartments);
      setSelectedDepartments([]);
      setSelectedSubDepartments([]);
    }
  };

  // Handle department change - filter sub-departments
  const handleDepartmentChange = (departmentIds, selectedOptions) => {
    setSelectedDepartments(departmentIds);

    if (departmentIds.length > 0) {
      // Filter sub-departments based on selected departments
      const subs = subDepartments.filter(sd => departmentIds.includes(sd.department_id));
      setFilteredSubDepartments(subs);

      // Keep only valid sub-departments
      const validSubDepartmentIds = selectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => (sd.id || sd.sub_department_id) === subDeptId);
      });
      setSelectedSubDepartments(validSubDepartmentIds);
    } else {
      // Reset to all sub-departments based on branches
      if (selectedBranches.length > 0) {
        const filtered = departments.filter(dept => selectedBranches.includes(dept.branch_id));
        const subs = subDepartments.filter(sd => filtered.some(d => d.id === sd.department_id));
        setFilteredSubDepartments(subs);
      } else {
        setFilteredSubDepartments(subDepartments);
      }
      setSelectedSubDepartments([]);
    }
  };

  // Handle sub-department change
  const handleSubDepartmentChange = (subDepartmentIds, selectedOptions) => {
    setSelectedSubDepartments(subDepartmentIds);
  };


  const getFileIcon = (file) => {
    // First try to get icon from classification
    // const classificationName = file.category_name || file.category?.name;
    // if (classificationName) {
    //   const classificationIcon = getClassificationIcon(classificationName);
    //   if (classificationIcon) {
    //     return classificationIcon;
    //   }
    // }

    // Get file extension from file_name first (most reliable)
    let extension = '';
    if (file.file_name) {
      extension = file.file_name.split('.').pop()?.toLowerCase() || '';
    } else if (file.name) {
      extension = file.name.split('.').pop()?.toLowerCase() || '';
    }
    
    // If we have file_type, check if it's a MIME type or extension
    let fileType = file.file_type?.toLowerCase() || '';
    
    if (fileType) {
      // Check if it's a MIME type (contains '/')
      if (fileType.includes('/')) {
        // Extract extension from MIME type
        const mimeToExt = {
          'application/pdf': 'pdf',
          'application/msword': 'doc',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'application/vnd.ms-excel': 'xls',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'application/vnd.ms-powerpoint': 'ppt',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'text/plain': 'txt',
          'application/zip': 'zip',
          'application/x-rar-compressed': 'rar',
          'application/x-zip-compressed': 'zip'
        };
        extension = mimeToExt[fileType] || extension;
      } else {
        // It's already an extension
        if (fileType[0] === '.') {
          fileType = fileType.substring(1);
        }
        extension = fileType || extension;
      }
    }
    
    // Use extension if we have it, otherwise fallback
    const fileTypeKey = extension || fileType || '';

    const iconMap = {
      pdf: 'pdf',
      doc: 'word',
      docx: 'word',
      xls: 'excel',
      xlsx: 'excel',
      ppt: 'powerpoint',
      pptx: 'powerpoint',
      jpg: 'image',
      jpeg: 'image',
      png: 'image',
      gif: 'image',
      txt: 'text',
      zip: 'archive',
      rar: 'archive',
      folder: 'folder'
    };

    return iconMap[fileTypeKey] || 'file';
  };

  const getFileIconColor = (fileType) => {
    const colorMap = {
      pdf: '#d93025',
      word: '#2b579a',
      excel: '#1d6f42',
      powerpoint: '#d04423',
      image: '#34a853',
      text: '#6c757d',
      archive: '#ea4335',
      file: '#667eea'
    };
    return colorMap[fileType] || colorMap.file;
  };

  const getClassificationIconComponent = (classificationName, size = 36, isFolder = false) => {
    const defaultColor = isFolder ? '#C42126' : '#667eea';
    
    if (!classificationName) {
      return <CategorizationIcon size={size} color={defaultColor} />;
    }

    return <CategorizationIcon size={size} color={defaultColor} />;
  };

  const getFileIconComponent = (file, size = 36, iconColor = null) => {
    if (file.type === 'folder') {
      
      // For folders, try to use classification if available
      const classificationName = file.category_name || file.category?.name;
      return getClassificationIconComponent(classificationName, size, true);
    }

    // Get normalized file type using existing getFileIcon function
    const normalizedType = getFileIcon(file);
    const color = iconColor || getFileIconColor(normalizedType);

    // Map normalized types to specific Font Awesome icons
    switch (normalizedType) {
      case 'pdf':
        return <FaFilePdf size={size} style={{ color }} />;
      case 'word':
        return <FaFileWord size={size} style={{ color }} />;
      case 'excel':
        return <FaFileExcel size={size} style={{ color }} />;
      case 'powerpoint':
        return <FaFilePowerpoint size={size} style={{ color }} />;
      case 'image':
        return <FaFileImage size={size} style={{ color }} />;
      case 'archive':
        return <FaFileArchive size={size} style={{ color }} />;
      case 'text':
        return <FaFileAlt size={size} style={{ color }} />;
      default:
        return <FiFile size={size} style={{ color }} />;
    }
  };

  const handleNavigateToFile = (item) => {
    if (item.type === 'folder') {
      // Navigate to folder location
      if (item.id) {
        navigate(`/documents/folder/${item.id}`);
      } else {
        navigate('/documents');
      }
    } else {
      // Navigate to file location
      if (item.folder_id || item.document_path_id) {
        const folderId = item.folder_id || item.document_path_id;
        navigate(`/documents/folder/${folderId}`);
      } else {
        navigate('/documents');
      }
    }
    notifySuccess('Navigating to location...');
  };

  const handleViewDetails = (item) => {
    if (item.type === 'file' && item.id) {
      navigate(`/documents/details/${item.id}`, {
        state: { from: location.pathname }
      });
    }
  };

  const handleUploadToFolder = (folder) => {
    // Find the classification ID by matching category_name or using category_id
    let categoryId = folder.category_id;
    
    // If no category_id but we have category_name, try to match it
    if (!categoryId && folder.category_name && documentClassifications.length > 0) {
      const matchingClassification = documentClassifications.find(cat => 
        cat.name.toLowerCase().trim() === folder.category_name.toLowerCase().trim()
      );
      if (matchingClassification) {
        categoryId = matchingClassification.id;
      }
    }
    
    // Navigate to upload document page with classification pre-filled
    const queryParams = new URLSearchParams();
    if (categoryId) {
      queryParams.append('categoryId', categoryId);
    }
    navigate(`/documents/upload?${queryParams.toString()}`);
  };

  const handleDownload = async (file) => {
    if (!file || !file.id) {
      notifyError('Invalid file');
      return;
    }

    try {
      setLoading(true);

      // Download file with blob response type
      const response = await axiosInstance.get(`/documents/${file.id}/download`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/octet-stream'
        }
      });

      if (response.status === 200) {
        // Get filename from Content-Disposition header or use file name
        let fileName = file.name || file.file_name || 'document';

        // Try to extract filename from Content-Disposition header
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''));
          }
        }

        // Create blob URL and trigger download
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        notifySuccess('File downloaded successfully');
      }
    } catch (error) {
      console.error('Error downloading file:', error);

      // Handle blob error response (if API returns JSON error in blob format)
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorJson = JSON.parse(errorText);
          notifyError(errorJson.message || 'Failed to download file');
        } catch (parseError) {
          notifyError('Failed to download file');
        }
      } else {
        const errorMessage = error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to download file';
        notifyError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  // Share form handlers
  const handleShareBranchChange = async (branchIds, selectedOptions) => {
    setShareSelectedBranches(branchIds);

    if (branchIds.length > 0) {
      const filtered = departments.filter(dept => branchIds.includes(dept.branch_id));
      setShareFilteredDepartments(filtered);

      const validDepartmentIds = shareSelectedDepartments.filter(deptId => {
        return filtered.some(d => d.id === deptId);
      });
      setShareSelectedDepartments(validDepartmentIds);

      let subs = [];
      if (validDepartmentIds.length > 0) {
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return validDepartmentIds.includes(sdDeptId);
        });
      } else {
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && branchIds.includes(dept.branch_id);
        });
      }
      setShareFilteredSubDepartments(subs);

      const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setShareSelectedSubDepartments(validSubDepartmentIds);

      await filterShareUsersBySelections(branchIds, validDepartmentIds, validSubDepartmentIds);
    } else {
      setShareFilteredDepartments(departments);

      if (shareSelectedDepartments.length > 0) {
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return shareSelectedDepartments.includes(sdDeptId);
        });
        setShareFilteredSubDepartments(subs);

        const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setShareSelectedSubDepartments(validSubDepartmentIds);

        await filterShareUsersBySelections([], shareSelectedDepartments, validSubDepartmentIds);
      } else {
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(shareAvailableUsers);
      }
    }
  };

  const handleShareDepartmentChange = async (departmentIds, selectedOptions) => {
    setShareSelectedDepartments(departmentIds);

    if (departmentIds.length > 0) {
      let subs = subDepartments.filter(sd => {
        const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
        return departmentIds.includes(sdDeptId);
      });

      if (shareSelectedBranches.length > 0) {
        subs = subs.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && shareSelectedBranches.includes(dept.branch_id);
        });
      }

      setShareFilteredSubDepartments(subs);

      const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setShareSelectedSubDepartments(validSubDepartmentIds);

      await filterShareUsersBySelections(shareSelectedBranches, departmentIds, validSubDepartmentIds);
    } else {
      if (shareSelectedBranches.length > 0) {
        const filtered = departments.filter(dept => shareSelectedBranches.includes(dept.branch_id));
        const filteredDeptIds = filtered.map(d => d.id);
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filteredDeptIds.includes(sdDeptId);
        });
        setShareFilteredSubDepartments(subs);

        const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setShareSelectedSubDepartments(validSubDepartmentIds);

        await filterShareUsersBySelections(shareSelectedBranches, [], validSubDepartmentIds);
      } else {
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(shareAvailableUsers);
        setShareSelectedSubDepartments([]);
      }
    }
  };

  const handleShareSubDepartmentChange = async (subDepartmentIds, selectedOptions) => {
    setShareSelectedSubDepartments(subDepartmentIds);
    await filterShareUsersBySelections(shareSelectedBranches, shareSelectedDepartments, subDepartmentIds);
  };

  const fetchShareUsersByFilters = async (branchIds, departmentIds, subDepartmentIds) => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      if (!corporateId) return [];

      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));

      if (branchIds && branchIds.length > 0) {
        params.append('branch', branchIds.join(','));
      }

      if (departmentIds && departmentIds.length > 0) {
        params.append('department', departmentIds.join(','));
      }

      if (subDepartmentIds && subDepartmentIds.length > 0) {
        params.append('sub_department', subDepartmentIds.join(','));
      }

      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];

      const filteredUsers = users.filter(user => user.id !== userData.id);

      return filteredUsers;
    } catch (error) {
      console.error('Error fetching users by filters:', error);
      return [];
    }
  };

  const filterShareUsersBySelections = async (branchIds, departmentIds, subDepartmentIds) => {
    if (branchIds.length > 0 || departmentIds.length > 0 || subDepartmentIds.length > 0) {
      const users = await fetchShareUsersByFilters(branchIds, departmentIds, subDepartmentIds);
      setShareFilteredUsers(users);

      if (shareSelectedUsers.length > 0) {
        const validUserIds = shareSelectedUsers.filter(userId =>
          users.some(user => {
            const userIdMatch = user.id === userId || user.CorporateUserId === userId;
            return userIdMatch;
          })
        );
        if (validUserIds.length !== shareSelectedUsers.length) {
          setShareSelectedUsers(validUserIds);
        }
      }
    } else {
      setShareFilteredUsers(shareAvailableUsers);
    }
  };

  const handleShareUserChange = (userIds, selectedOptions) => {
    setShareSelectedUsers(userIds);
  };

  // Handle share document (internal)
  const handleShareDocument = async () => {
    if (!shareSelectedItem || !shareSelectedItem.id) {
      notifyError('Invalid document');
      return;
    }

    try {
      setSharing(true);

      const payload = buildDocumentSharePayload(
        shareSelectedBranches,
        shareSelectedDepartments,
        shareSelectedSubDepartments,
        shareSelectedUsers
      );

      const response = await axiosInstance.put(`/documents/${shareSelectedItem.id}/share`, payload);

      if (response.status === 200) {
        notifySuccess('Document shared successfully');
        setShowShareModal(false);
        // Reset form
        setShareSelectedBranches([]);
        setShareSelectedDepartments([]);
        setShareSelectedSubDepartments([]);
        setShareSelectedUsers([]);
        setShareFilteredDepartments(departments);
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(shareAvailableUsers);
        setShareSelectedItem(null);
        // Refresh documents
        await loadRecentDocuments();
      }
    } catch (error) {
      console.error('Error sharing document:', error);
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to share document';
      notifyError(errorMessage);
    } finally {
      setSharing(false);
    }
  };

  // Handle email share document
  const handleEmailShareDocument = async (payload) => {
    if (!shareSelectedItem || !shareSelectedItem.id) {
      notifyError('Invalid document');
      return;
    }

    try {
      setSharing(true);

      const requestPayload = {
        fileId: shareSelectedItem.id,
        email: payload.email,
        permission: 'read',
        expiryOption: payload.expiryOption || 'never'
      };

      const response = await axiosInstance.post('/api/share', requestPayload);

      if (response.status === 200 || response.status === 201) {
        notifySuccess('Document shared via email successfully');
        setShowShareModal(false);
        setShareSelectedItem(null);
        // Refresh documents
        await loadRecentDocuments();
      }
    } catch (error) {
      console.error('Error sharing document via email:', error);
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to share document via email';
      notifyError(errorMessage);
    } finally {
      setSharing(false);
    }
  };

  // Reset share form
  const resetShareForm = () => {
    setShareSelectedBranches([]);
    setShareSelectedDepartments([]);
    setShareSelectedSubDepartments([]);
    setShareSelectedUsers([]);
    setShareFilteredDepartments(departments);
    setShareFilteredSubDepartments(subDepartments);
    setShareFilteredUsers(shareAvailableUsers);
    setShareSelectedItem(null);
  };

  // Generate unique filename by appending timestamp
  const generateUniqueFileName = (originalFileName) => {
    const fileExtension = originalFileName.split('.').pop();
    const fileNameWithoutExt = originalFileName.substring(0, originalFileName.lastIndexOf('.'));
    const timestamp = Date.now();
    const randomId = Math.random().toString(36).substring(2, 8); // 6 character random ID
    return `${fileNameWithoutExt}_${timestamp}_${randomId}.${fileExtension}`;
  };

  // Check for duplicate files
  const checkDuplicates = async (files) => {
    if (!files || files.length === 0) return [];

    setCheckingDuplicates(true);
    const duplicateResults = [];

    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      // Check each file for duplicates
      const checkPromises = files.map(async (file) => {
        try {
          const payload = {
            file_name: file.name,
            document_path_id: null,
            corporation_id: corporateId,
            branch_id: selectedBranches.length > 0 ? selectedBranches[0] : null,
            department_id: selectedDepartments.length > 0 ? selectedDepartments[0] : null,
            subdepartment_id: selectedSubDepartments.length > 0 ? selectedSubDepartments[0] : null
          };

          const response = await axiosInstance.post('/documents/check-duplicate', payload);
          const data = response.data;

          if (data.isDuplicate) {
            return {
              file: file,
              isDuplicate: true,
              duplicateData: data.data
            };
          }

          return {
            file: file,
            isDuplicate: false
          };
        } catch (error) {
          console.error(`Error checking duplicate for ${file.name}:`, error);
          // If check fails, assume no duplicate (allow upload)
          return {
            file: file,
            isDuplicate: false,
            error: true
          };
        }
      });

      const results = await Promise.all(checkPromises);
      duplicateResults.push(...results.filter(r => r.isDuplicate));

      return duplicateResults;
    } catch (error) {
      console.error('Error checking duplicates:', error);
      return [];
    } finally {
      setCheckingDuplicates(false);
    }
  };

  // Process files based on user choices for duplicates
  const processFilesWithChoices = (files, duplicateChoices) => {
    return files.map((file) => {
      const choice = duplicateChoices[file.name];

      if (choice === 'replace') {
        // Use original name (will replace existing file)
        return {
          originalFile: file,
          processedFile: file,
          originalName: file.name,
          newName: file.name,
          wasRenamed: false,
          action: 'replace'
        };
      } else if (choice === 'copy') {
        // Generate unique filename (keep as copy)
        const newFileName = generateUniqueFileName(file.name);
        const renamedFile = new File([file], newFileName, {
          type: file.type,
          lastModified: file.lastModified
        });

        return {
          originalFile: file,
          processedFile: renamedFile,
          originalName: file.name,
          newName: newFileName,
          wasRenamed: true,
          action: 'copy'
        };
      }

      // No duplicate or no choice made yet - use original
      return {
        originalFile: file,
        processedFile: file,
        originalName: file.name,
        newName: file.name,
        wasRenamed: false,
        action: null
      };
    });
  };

  const handleFileUpload = async () => {
    if (uploadFiles.length === 0) {
      notifyError('Please select files to upload');
      return;
    }

    // Validate required dynamic fields only if a classification is selected
    if (selectedCategory) {
      const selectedCategoryData = documentClassifications.find(cat => cat.id === selectedCategory);
      if (selectedCategoryData && selectedCategoryData.fields) {
        const requiredFields = selectedCategoryData.fields.filter(field => field.is_required);
        const missingFields = requiredFields.filter(field => {
          const fieldValue = dynamicFields[field.id];
          return !fieldValue || fieldValue.trim() === '';
        });

        if (missingFields.length > 0) {
          notifyError(`Please fill in all required fields: ${missingFields.map(f => f.field_name).join(', ')}`);
          return;
        }
      }
    }

    // Check for duplicates
    const duplicates = await checkDuplicates(uploadFiles);

    // If duplicates found, show modal for user to choose
    if (duplicates.length > 0) {
      setDuplicateFiles(duplicates);
      // Initialize choices with default 'copy' for all duplicates
      const initialChoices = {};
      duplicates.forEach(dup => {
        initialChoices[dup.file.name] = 'copy'; // Default to 'copy'
      });
      setDuplicateChoices(initialChoices);
      setShowDuplicateModal(true);
      return; // Wait for user to make choices
    }

    // No duplicates, proceed with upload
    proceedWithUpload(uploadFiles, {});
  };

  // Proceed with upload after user makes duplicate choices
  const proceedWithUpload = async (files, choices) => {
    setLoading(true);

    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      // Process files based on user choices
      const processedFiles = processFilesWithChoices(files, choices);

      // Upload each file
      const uploadPromises = processedFiles.map(async (fileInfo) => {
        try {
          const formData = new FormData();

          // Required fields
          formData.append('file', fileInfo.processedFile);
          formData.append('corporation_id', corporateId);

          // Optional fields
          if (fileInfo.action) {
            // Use user's choice for duplicate_action
            formData.append('duplicate_action', fileInfo.action);
          } else {
            // Default to 'copy' if no duplicate was found
            formData.append('duplicate_action', 'copy');
          }

          // document_path_id is optional - omit if null

          if (selectedCategory) {
            formData.append('category_id', selectedCategory);
          }

          if (Object.keys(dynamicFields).length > 0) {
            formData.append('field_values', JSON.stringify(dynamicFields));
          }

          if (isPrivate) {
            formData.append('is_private', isPrivate);
          }

          if (selectedBranches.length > 0) {
            formData.append('branch_ids', JSON.stringify(selectedBranches));
          }

          if (selectedDepartments.length > 0) {
            formData.append('department_ids', JSON.stringify(selectedDepartments));
          }

          if (selectedSubDepartments.length > 0) {
            formData.append('sub_department_ids', JSON.stringify(selectedSubDepartments));
          }

          // Upload file
          const response = await axiosInstance.post('/documents/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          return {
            success: true,
            fileInfo: fileInfo,
            response: response.data
          };
        } catch (error) {
          console.error(`Error uploading ${fileInfo.originalName}:`, error);
          return {
            success: false,
            fileInfo: fileInfo,
            error: error.response?.data || error.message
          };
        }
      });

      const results = await Promise.all(uploadPromises);

      // Check for failures
      const failures = results.filter(r => !r.success);
      const successes = results.filter(r => r.success);

      if (failures.length > 0) {
        const failedNames = failures.map(f => f.fileInfo.originalName).join(', ');
        notifyError(`Failed to upload: ${failedNames}`);
      }

      if (successes.length > 0) {
        // Show success message with rename info if any files were renamed
        const renamedCount = processedFiles.filter(f => f.wasRenamed).length;
        const replacedCount = processedFiles.filter(f => f.action === 'replace').length;

        if (renamedCount > 0) {
          const renamedNames = processedFiles
            .filter(f => f.wasRenamed)
            .map(f => `${f.originalName} → ${f.newName}`)
            .join(', ');
          notifySuccess(`${renamedCount} file(s) saved as copy: ${renamedNames}`);
        }

        if (replacedCount > 0) {
          notifySuccess(`${replacedCount} file(s) replaced existing file(s)`);
        }

        if (renamedCount === 0 && replacedCount === 0) {
          notifySuccess(`${successes.length} file(s) uploaded successfully`);
        }

        // Reload recent documents from API to show the new files
        await loadRecentDocuments();
      }

      // Reset form and close modals
      setShowUploadModal(false);
      setShowDuplicateModal(false);
      setUploadFiles([]);
      setSelectedCategory(null);
      setDynamicFields({});
      setIsPrivate(false);
      setSelectedBranches([]);
      setSelectedDepartments([]);
      setSelectedSubDepartments([]);
      setFilteredDepartments(departments);
      setFilteredSubDepartments(subDepartments);
      setDuplicateFiles([]);
      setDuplicateChoices({});
    } catch (error) {
      console.error('Error uploading files:', error);
      notifyError('Failed to upload files. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Load available categories for parent selection
  useEffect(() => {
    if (showFolderModal) {
      const loadClassifications = async () => {
        setLoadingClassificationsForParent(true);
        try {
          const userData = JSON.parse(localStorage.getItem('user'));
          const corporateId = userData?.corporateId || userData?.id;

          const response = await axiosInstance.get(`/document-categories?corporate_id=${corporateId}`);
          const data = response.data;

          if (response.status === 200) {
            const classifications = data.success ? data.data : (data.data || data || []);
            setAvailableClassificationsForParent(classifications);

            // Prefill parent_id if prefillParentId is set
            if (prefillParentId) {
              setClassificationFormData(prev => ({
                ...prev,
                parent_id: prefillParentId
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching classifications:", error);
        } finally {
          setLoadingClassificationsForParent(false);
        }
      };

      loadClassifications();
    } else {
      // Reset prefill when modal closes
      setPrefillParentId(null);
    }
  }, [showFolderModal, prefillParentId]);

  // Show loading while checking access (after all hooks)
  if (accessLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Don't render if no access (will redirect)
  if (!hasAccess) {
    return null;
  }

  const FIELD_TYPES = [
    { value: "0", label: "Select Type" },
    { value: "text", label: "Text (varchar 200)" },
    { value: "date", label: "Date (date)" },
    { value: "address", label: "Address (longtext)" }
  ];

  const createField = () => ({
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    fieldName: "",
    fieldType: "0"
  });

  const handleClassificationFormChange = (e, index, type) => {
    if (type === "classification") {
      setClassificationFormData({ ...classificationFormData, name: e.target.value });
      if (classificationFormErrors.name) {
        const { name, ...rest } = classificationFormErrors;
        setClassificationFormErrors(rest);
      }
    } else if (type === "parent_id") {
      const parentId = e.target.value === "" ? null : parseInt(e.target.value);
      setClassificationFormData({ ...classificationFormData, parent_id: parentId });
      if (classificationFormErrors.parent_id) {
        const { parent_id, ...rest } = classificationFormErrors;
        setClassificationFormErrors(rest);
      }
    } else {
      const updatedFields = [...classificationFormData.fields];
      updatedFields[index][type] = e.target.value;
      setClassificationFormData({ ...classificationFormData, fields: updatedFields });
      const key = `${type}_${index}`;
      if (classificationFormErrors[key]) {
        const { [key]: _, ...rest } = classificationFormErrors;
        setClassificationFormErrors(rest);
      }
    }
  };

  const addClassificationField = () => {
    setClassificationFormData({
      ...classificationFormData,
      fields: [...classificationFormData.fields, createField()]
    });
  };

  const deleteClassificationField = (index) => {
    if (classificationFormData.fields.length === 1) {
      notifyError("At least one field is required!");
      return;
    }
    const updatedFields = classificationFormData.fields.filter((_, i) => i !== index);
    setClassificationFormData({ ...classificationFormData, fields: updatedFields });
  };

  const validateClassificationForm = () => {
    const newErrors = {};

    if (!classificationFormData.name.trim()) {
      newErrors.name = 'Document Classification name is required';
    }

    const seenNames = new Set();
    classificationFormData.fields.forEach((f, idx) => {
      if (!f.fieldName.trim()) {
        newErrors[`fieldName_${idx}`] = "Field name required";
      }
      if (f.fieldType === "0") {
        newErrors[`fieldType_${idx}`] = "Select field type";
      }
      const normalized = f.fieldName.trim().toLowerCase();
      if (normalized) {
        if (seenNames.has(normalized)) {
          newErrors[`fieldName_${idx}`] = "Duplicate field name";
        }
        seenNames.add(normalized);
      }
    });

    setClassificationFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateClassification = async () => {
    if (!validateClassificationForm()) return;

    try {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;

      // Transform fields for backend API
      const payloadFields = classificationFormData.fields.map((f, idx) => ({
        field_name: f.fieldName,
        field_type: f.fieldType,
        field_order: idx + 1,
        is_required: false
      }));

      const payload = {
        name: classificationFormData.name.trim(),
        corporate_id: parseInt(corporateId),
        fields: payloadFields,
      };

      // Add parent_id if selected
      if (classificationFormData.parent_id) {
        payload.parent_id = classificationFormData.parent_id;
      }

      const response = await axiosInstance.post('/document-categories', payload);

      if (response.status === 200 || response.status === 201) {
        const responseData = response.data;

        if (responseData.success) {
          notifySuccess(responseData.message || 'Document Classification created successfully');
          setShowFolderModal(false);
          setClassificationFormData({
            name: '',
            parent_id: null,
            fields: [createField()]
          });
          setClassificationFormErrors({});
          // Reload classifications and recent documents
          await loadDocumentClassifications();
          await loadRecentDocuments();
        } else {
          notifyError(responseData.message || 'Failed to create classification');
        }
      }
    } catch (error) {
      console.error('Error creating classification:', error);
      if (error.response?.status === 409) {
        notifyError('Document Classification already exists');
      } else {
        const errorMessage = error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to create Document Classification';
        notifyError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  // Check if date string represents a date-only value (time is 00:00:00.000Z)
  const isDateOnly = (dateString) => {
    if (!dateString) return false;
    // Check if the time portion is 00:00:00.000Z or T00:00:00
    const dateStr = String(dateString);
    return /T00:00:00(\.000)?Z?$/.test(dateStr) || /T00:00:00(\.000)?$/.test(dateStr);
  };

  const formatTimeAgo = (dateString, showDateOnly = false) => {
    // If it's a date-only value, format as DD-MMM-YYYY
    if (isDateOnly(dateString) || showDateOnly) {
      return formatDateToDDMMMYYYY(dateString);
    }

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

    // For dates older than 7 days, show only date without time
    return formatDateToDDMMMYYYY(dateString);
  };

  const menuIcon = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const fileTypeOptions = [
    { value: 'all', label: 'All Files' },
    { value: 'pdf', label: 'PDF' },
    { value: 'word', label: 'Word' },
    { value: 'excel', label: 'Excel' },
    { value: 'powerpoint', label: 'PowerPoint' },
    { value: 'image', label: 'Images' },
    { value: 'other', label: 'Other' }
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="document-drive-container">
      <ToastContainer />

      <Row className="mb-4">
        <Col lg={12}>
          <div className="document-section">
            {/* First Row: Title, Search, and Action Buttons */}
            <div className="document-section-header d-flex justify-content-between align-items-center flex-wrap gap-3" style={{ padding: '1.5rem 1.5rem 1rem 1.5rem', borderBottom: '1px solid #e9ecef' }}>
              <h4 className="mb-0" style={{ fontSize: '1.25rem', fontWeight: '600', color: '#2c3e50' }}>Dashboard</h4>
              <div className="d-flex align-items-center gap-3 justify-content-end" style={{ maxWidth: isMobile ? '100%' : '600px', flexGrow: isMobile ? 0 : 1 }}>
                {/* Search Input - Desktop */}
                {!isMobile && (
                  <div className="position-relative flex-grow-1" style={{ maxWidth: '400px' }}>
                    <div className="position-relative">
                      <FiSearch 
                        className="position-absolute" 
                        style={{ 
                          left: '12px', 
                          top: '50%', 
                          transform: 'translateY(-50%)', 
                          color: '#6c757d',
                          pointerEvents: 'none',
                          zIndex: 1
                        }} 
                        size={18}
                      />
                      <Form.Control
                        type="text"
                        placeholder="Search documents and classifications..."
                        value={dashboardSearchQuery}
                        onChange={(e) => setDashboardSearchQuery(e.target.value)}
                        style={{
                          paddingLeft: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          border: '1px solid #e9ecef',
                          fontSize: '0.875rem'
                        }}
                      />
                      {dashboardSearchQuery && (
                        <button
                          onClick={() => {
                            setDashboardSearchQuery('');
                            setSearchResults([]);
                            setSearchError(null);
                          }}
                          style={{
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#6c757d'
                          }}
                          title="Clear search"
                        >
                          <FiX size={18} />
                        </button>
                      )}
                    </div>
                  </div>
                )}
                {/* Mobile Search Icon Button */}
                {isMobile && !isMobileSearchOpen && (
                  <button
                    onClick={() => setIsMobileSearchOpen(true)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#6c757d',
                      borderRadius: '8px',
                      transition: 'background 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.background = 'none'}
                    title="Search documents and classifications"
                  >
                    <FiSearch size={20} />
                  </button>
                )}
                <div className="document-toolbar-actions">
                  <button
                    className="document-action-btn-modern"
                    onClick={() => {
                      // Navigate to upload page instead of opening modal
                      navigate('/documents/upload');
                    }}
                    title="Upload Document"
                  >
                    <FiUpload />
                    <span className="btn-label d-none d-md-inline">Upload</span>
                  </button>
                  <button
                    className="document-action-btn-modern"
                    onClick={() => {
                      // Navigate to add classification page instead of opening modal
                      navigate('/documents/addDocumentClassification');
                    }}
                    title="New Classification"
                  >
                    <CategorizationIcon size={20} color="white" />
                    <span className="btn-label d-none d-md-inline">New</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Mobile Search Input Row - Full Width */}
            {isMobile && isMobileSearchOpen && (
              <div className="w-100" style={{ padding: '0 1.5rem 1rem 1.5rem', borderBottom: '1px solid #e9ecef' }}>
                <div className="position-relative">
                  <FiSearch 
                    className="position-absolute" 
                    style={{ 
                      left: '12px', 
                      top: '50%', 
                      transform: 'translateY(-50%)', 
                      color: '#6c757d',
                      pointerEvents: 'none',
                      zIndex: 1
                    }} 
                    size={18}
                  />
                  <Form.Control
                    type="text"
                    placeholder="Search documents and classifications..."
                    value={dashboardSearchQuery}
                    onChange={(e) => setDashboardSearchQuery(e.target.value)}
                    autoFocus
                    style={{
                      paddingLeft: '40px',
                      paddingRight: '40px',
                      height: '40px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '0.875rem',
                      width: '100%'
                    }}
                  />
                  <button
                    onClick={() => {
                      setIsMobileSearchOpen(false);
                      setDashboardSearchQuery('');
                      setSearchResults([]);
                      setSearchError(null);
                    }}
                    style={{
                      position: 'absolute',
                      right: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#6c757d'
                    }}
                    title="Close search"
                  >
                    <FiX size={18} />
                  </button>
                </div>
              </div>
            )}

            {/* Search Results or Document Suggestions Section */}
            {dashboardSearchQuery.trim() ? (
              /* Search Results Section */
              <div className="search-results-section" style={{ padding: '1.5rem', borderBottom: '1px solid #e9ecef' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '600', color: '#2c3e50' }}>
                    Search Results {searchResults.length > 0 && `(${searchResults.length})`}
                  </h5>
                </div>
                <div>
                  {searchLoading ? (
                    <div className="d-flex justify-content-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Searching...</span>
                      </div>
                    </div>
                  ) : searchError ? (
                    <div className="text-center py-5">
                      <p className="text-muted mb-3">{searchError}</p>
                      <Button variant="primary" size="sm" onClick={() => performSearch(dashboardSearchQuery)}>
                        <FiRefreshCw className="me-2" />
                        Try again
                      </Button>
                    </div>
                  ) : searchResults.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                      No documents found matching "{dashboardSearchQuery}"
                    </div>
                  ) : (
                    <div className="row">
                      <CommonTable
                        columns={[
                          {
                            key: 'icon',
                            header: '',
                            render: (row) => {
                              const fileIconType = getFileIcon(row);
                              const iconColor = getFileIconColor(fileIconType);
                              return (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {getFileIconComponent(row, 20, iconColor)}
                                </div>
                              );
                            },
                            cellClassName: 'width80',
                          },
                          {
                            key: 'title',
                            header: 'Title',
                            render: (row) => (
                              <div
                                onClick={() => {
                                  if (row.type === 'file') {
                                    handleViewDetails(row);
                                  } else {
                                    handleNavigateToFile(row);
                                  }
                                }}
                                style={{ cursor: 'pointer', color: '#2c3e50' }}
                                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                                onMouseLeave={(e) => e.target.style.color = '#2c3e50'}
                              >
                                {row.document_title || row.name}
                              </div>
                            ),
                          },
                          {
                            key: 'classification',
                            header: 'Classification',
                            headerClassName: 'hide-on-mobile',
                            cellClassName: 'hide-on-mobile',
                            render: (row) => (
                              <span className="text-muted">{row.category_name || 'N/A'}</span>
                            ),
                          },
                          {
                            key: 'reference',
                            header: 'Reference Number',
                            headerClassName: 'hide-on-mobile',
                            cellClassName: 'hide-on-mobile',
                            render: (row) => (
                              <span className="text-muted">{row.document_reference_number || row.reference_number || '—'}</span>
                            ),
                          },
                          {
                            key: 'expiry',
                            header: 'Expiry Date',
                            headerClassName: 'hide-on-mobile',
                            cellClassName: 'hide-on-mobile',
                            render: (row) => {
                              const expiryDate = row.document_expiry_date || row.expiry_date;
                              if (!expiryDate) return <span className="text-muted">—</span>;
                              try {
                                if (isDateOnly(expiryDate)) {
                                  return <span className="text-muted">{formatDateToDDMMMYYYY(expiryDate)}</span>;
                                }
                                return <span className="text-muted">{formatTimeAgo(expiryDate)}</span>;
                              } catch (e) {
                                return <span className="text-muted">{expiryDate}</span>;
                              }
                            },
                          },
                          {
                            key: 'uploaded',
                            header: 'Uploaded Date',
                            headerClassName: 'hide-on-mobile',
                            cellClassName: 'hide-on-mobile',
                            render: (row) => {
                              const uploadDate = row.created_at || row.uploaded_at;
                              if (!uploadDate) return <span className="text-muted">N/A</span>;
                              try {
                                return <span className="text-muted">{formatTimeAgo(uploadDate)}</span>;
                              } catch (e) {
                                return <span className="text-muted">N/A</span>;
                              }
                            },
                          },
                          {
                            key: 'uploadedBy',
                            header: 'Uploaded by',
                            headerClassName: 'hide-on-mobile',
                            cellClassName: 'hide-on-mobile',
                            render: (row) => (
                              <span className="text-muted">
                                {row.uploaded_by || row.created_by_name || '—'}
                              </span>
                            ),
                          },
                        ]}
                        data={searchResults}
                        actions={(row, rowIndex) => {
                          const isFolder = row.type === 'folder';
                          const actions = [];
                          
                          if (!isFolder) {
                            actions.push({
                              label: 'View Details',
                              icon: 'fas fa-file',
                              onClick: () => handleViewDetails(row),
                            });
                          } else {
                            actions.push({
                              label: 'Upload Document',
                              icon: 'fas fa-upload',
                              onClick: () => handleUploadToFolder(row),
                            });
                          }
                          
                          if (!isFolder) {
                            actions.push({
                              label: 'Download',
                              icon: 'fas fa-download',
                              onClick: () => handleDownload(row),
                            });
                            actions.push({
                              label: 'Share',
                              icon: 'fas fa-share',
                              onClick: () => {
                                setShareSelectedItem(row);
                                setShowShareModal(true);
                                setShareFilteredDepartments(departments);
                                setShareFilteredSubDepartments(subDepartments);
                                setShareFilteredUsers(shareAvailableUsers);
                              },
                            });
                          }
                          
                          return actions;
                        }}
                        emptyMessage="No search results found"
                        emptyStateIcon="fas fa-search"
                        getRowId={(row, index) => row.id || index}
                        maxHeight="70vh"
                        minHeight="400px"
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              /* Document Suggestions Section */
              <div className="document-suggestions-section" style={{ padding: '1.5rem', borderBottom: '1px solid #e9ecef' }}>
              {/* Title and Scroll Buttons */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '600', color: '#2c3e50' }}>Document Suggestions</h5>
                {!suggestionsLoading && !suggestionsError && documentSuggestions.length > 0 && (
                  <div className="d-flex gap-2">
                    <button
                      className="scroll-btn"
                      onClick={() => {
                        if (suggestionsScrollRef.current) {
                          suggestionsScrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
                        }
                      }}
                      title="Scroll Left"
                    >
                      <FiChevronLeft size={14} />
                    </button>
                    <button
                      className="scroll-btn"
                      onClick={() => {
                        if (suggestionsScrollRef.current) {
                          suggestionsScrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
                        }
                      }}
                      title="Scroll Right"
                    >
                      <FiChevronRight size={14} />
                    </button>
                  </div>
                )}
              </div>

              {/* Documents Section */}
              <div>
                {suggestionsLoading ? (
                  <div className="d-flex justify-content-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading suggestions...</span>
                    </div>
                  </div>
                ) : suggestionsError ? (
                  <div className="text-center py-5">
                    <p className="text-muted mb-3">{suggestionsError}</p>
                    <Button variant="primary" size="sm" onClick={loadDocumentSuggestions}>
                      <FiRefreshCw className="me-2" />
                      Try again
                    </Button>
                  </div>
                ) : documentSuggestions.length === 0 ? (
                  <div className="text-center py-5 text-muted">
                    No suggestions available right now.
                  </div>
                ) : (
                  <div
                    ref={suggestionsScrollRef}
                    style={{
                      overflowX: 'auto',
                      paddingBottom: '16px',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none'
                    }}
                    className="document-suggestions-scroll"
                  >
                    <Row className="g-3 flex-nowrap">
                      {documentSuggestions.map((item) => {
                        const fileIconType = getFileIcon(item);
                        const iconColor = getFileIconColor(fileIconType);

                        return (
                          <Col key={`suggestion-${item.id}`} style={{ minWidth: '240px', maxWidth: '280px', flex: '0 0 auto' }}>
                            <div
                              className="document-suggestion-item"
                              onClick={() => handleViewDetails(item)}
                              style={{
                                height: '100%',
                                border: '1px solid #e9ecef',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                padding: '1rem',
                                display: 'flex',
                                flexDirection: 'column',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                background: 'white'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.borderColor = '#C42126';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.borderColor = '#e9ecef';
                              }}
                            >
                              {/* Icon and Name in one row */}
                              <div className="d-flex align-items-center gap-2 mb-2">
                                <div
                                  style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '8px',
                                    background: `${iconColor}1a`,
                                    color: iconColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                  }}
                                >
                                  {getFileIconComponent(item, 24)}
                                </div>
                                <h6
                                  className="mb-0 text-truncate flex-grow-1"
                                  title={item.document_title || item.name}
                                  style={{
                                    fontSize: '0.8rem',
                                    fontWeight: '500',
                                    color: '#2c3e50',
                                    lineHeight: '1.4'
                                  }}
                                >
                                  {item.document_title || item.name}
                                </h6>
                              </div>

                              {/* Category if exists */}
                              {item.category_name && (
                                <div className="mb-2">
                                  <small
                                    className="d-block"
                                    title={item.category_name}
                                    style={{
                                      fontSize: '0.7rem',
                                      color: '#2c3e50',
                                      fontWeight: '500'
                                    }}
                                  >
                                    {item.category_name}
                                  </small>
                                </div>
                              )}

                              {/* Reason if exists */}
                              {item.reason && (
                                <div className="mb-2">
                                  <p className="mb-0 text-muted small" style={{ fontSize: '0.75rem', lineHeight: '1.4' }}>
                                    {item.reason}
                                  </p>
                                </div>
                              )}

                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                )}
              </div>
            </div>
            )}

            {/* Recent Files Section - Only show when not searching */}
            {!dashboardSearchQuery.trim() && (
            <div className="recent-files-section">
              <div className="document-section-header d-flex justify-content-between align-items-center flex-wrap gap-2" style={{ padding: '1.5rem 1.5rem 1rem 1.5rem', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '600', color: '#2c3e50' }}>Recent Files and Classifications</h5>
              </div>

              <div className="document-section-body" style={{ minHeight: '400px', overflow: 'visible', padding: '1.5rem' }}>
                {filteredFiles.length === 0 ? (
                  <div className="text-center py-5" style={{ minHeight: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <FiFolder size={64} className="text-muted mb-4" style={{ opacity: 0.5 }} />
                    <h5 className="text-muted mb-3" style={{ fontSize: '1.1rem', fontWeight: '500' }}>No recent files or classifications</h5>
                    <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>Get started by uploading a document or creating a new classification</p>
                    <div className="d-flex gap-3 justify-content-center flex-wrap">
                      <button
                        onClick={() => {
                          navigate('/documents/upload');
                        }}
                        title="Upload Document"
                        style={{
                          minWidth: '150px',
                          background: 'transparent',
                          border: '2px solid #C42126',
                          borderRadius: '8px',
                          padding: '0.5rem 1.25rem',
                          color: '#C42126',
                          fontWeight: '600',
                          fontSize: '0.875rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '0.5rem',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#C42126';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'transparent';
                          e.target.style.color = '#C42126';
                        }}
                      >
                        <FiUpload />
                        <span>Upload</span>
                      </button>
                      <button
                        onClick={() => {
                          navigate('/documents/addDocumentClassification');
                        }}
                        title="New Classification"
                        onMouseEnter={() => setNewButtonHovered(true)}
                        onMouseLeave={() => setNewButtonHovered(false)}
                        style={{
                          minWidth: '150px',
                          background: newButtonHovered ? '#C42126' : 'transparent',
                          border: '2px solid #C42126',
                          borderRadius: '8px',
                          padding: '0.5rem 1.25rem',
                          color: newButtonHovered ? 'white' : '#C42126',
                          fontWeight: '600',
                          fontSize: '0.875rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '0.5rem',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <CategorizationIcon size={20} color={newButtonHovered ? 'white' : '#C42126'} />
                        <span>New</span>
                      </button>
                    </div>
                  </div>
                ) : (
                <div className="row">
                  <CommonTable
                    columns={[
                      {
                        key: 'icon',
                        header: '',
                        render: (row) => {
                          const fileIconType = getFileIcon(row);
                          const iconColor = getFileIconColor(fileIconType);
                          return (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {getFileIconComponent(row, 20, iconColor)}
                            </div>
                          );
                        },
                        cellClassName: 'width80',
                      },
                      {
                        key: 'title',
                        header: 'Title',
                        render: (row) => (
                          <div
                            onClick={() => {
                              if (row.type === 'file') {
                                handleViewDetails(row);
                              } else {
                                handleNavigateToFile(row);
                              }
                            }}
                            style={{ cursor: 'pointer', color: '#2c3e50' }}
                            onMouseEnter={(e) => e.target.style.color = '#667eea'}
                            onMouseLeave={(e) => e.target.style.color = '#2c3e50'}
                          >
                            {row.document_title || row.name}
                          </div>
                        ),
                      },
                      {
                        key: 'classification',
                        header: 'Classification',
                        headerClassName: 'hide-on-mobile',
                        cellClassName: 'hide-on-mobile',
                        render: (row) => (
                          <span className="text-muted">{row.category_name || 'N/A'}</span>
                        ),
                      },
                      {
                        key: 'reference',
                        header: 'Reference Number',
                        headerClassName: 'hide-on-mobile',
                        cellClassName: 'hide-on-mobile',
                        render: (row) => (
                          <span className="text-muted">{row.document_reference_number || row.reference_number || '—'}</span>
                        ),
                      },
                      {
                        key: 'expiry',
                        header: 'Expiry Date',
                        headerClassName: 'hide-on-mobile',
                        cellClassName: 'hide-on-mobile',
                        render: (row) => {
                          const expiryDate = row.document_expiry_date || row.expiry_date;
                          if (!expiryDate) return <span className="text-muted">—</span>;
                          try {
                            // If it's a date-only value, format as DD-MMM-YYYY, otherwise use formatTimeAgo
                            if (isDateOnly(expiryDate)) {
                              return <span className="text-muted">{formatDateToDDMMMYYYY(expiryDate)}</span>;
                            }
                            return <span className="text-muted">{formatTimeAgo(expiryDate)}</span>;
                          } catch (e) {
                            return <span className="text-muted">{expiryDate}</span>;
                          }
                        },
                      },
                      {
                        key: 'uploaded',
                        header: 'Updated Date',
                        headerClassName: 'hide-on-mobile',
                        cellClassName: 'hide-on-mobile',
                        render: (row) => {
                          const uploadDate = row.updated_at || row.created_at;
                          if (!uploadDate) return <span className="text-muted">N/A</span>;
                          try {
                            // Use formatTimeAgo - it will show relative time for recent dates,
                            // and DD-MMM-YYYY format for date-only values or dates older than 7 days
                            return <span className="text-muted">{formatTimeAgo(uploadDate)}</span>;
                          } catch (e) {
                            return <span className="text-muted">N/A</span>;
                          }
                        },
                      },
                      {
                        key: 'uploadedBy',
                        header: 'Uploaded by',
                        headerClassName: 'hide-on-mobile',
                        cellClassName: 'hide-on-mobile',
                        render: (row) => (
                          <span className="text-muted">
                            {row.uploaded_by || row.created_by_name || '—'}
                          </span>
                        ),
                      },
                    ]}
                    data={filteredFiles}
                    actions={(row, rowIndex) => {
                      const isFolder = row.type === 'folder';
                      const actions = [];
                      
                      if (!isFolder) {
                        actions.push({
                          label: 'View Details',
                          icon: 'fas fa-file',
                          onClick: () => handleViewDetails(row),
                        });
                      } else {
                        // For folders (classifications), show Upload Document instead of Go to Location
                        actions.push({
                          label: 'Upload Document',
                          icon: 'fas fa-upload',
                          onClick: () => handleUploadToFolder(row),
                        });
                      }
                      
                      if (!isFolder) {
                        actions.push({
                          label: 'Download',
                          icon: 'fas fa-download',
                          onClick: () => handleDownload(row),
                        });
                        actions.push({
                          label: 'Share',
                          icon: 'fas fa-share',
                          onClick: () => {
                            setShareSelectedItem(row);
                            setShowShareModal(true);
                            setShareFilteredDepartments(departments);
                            setShareFilteredSubDepartments(subDepartments);
                            setShareFilteredUsers(shareAvailableUsers);
                          },
                        });
                      }
                      
                      return actions;
                    }}
                    emptyMessage={searchTerm || filterType !== 'all'
                      ? 'No files match your search criteria'
                      : 'No recent files'}
                    emptyStateIcon="fas fa-clock"
                    getRowId={(row, index) => row.id || index}
                    maxHeight="70vh"
                    minHeight="400px"
                  />
                </div>
                )}
              </div>
            </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Upload Modal */}
      <Modal
        show={showUploadModal}
        onHide={() => {
          setShowUploadModal(false);
          setUploadFiles([]);
          setSelectedCategory(null);
          setDynamicFields({});
          setIsPrivate(false);
          setSelectedBranches([]);
          setSelectedDepartments([]);
          setSelectedSubDepartments([]);
          setFilteredDepartments(departments);
          setFilteredSubDepartments(subDepartments);
          setDuplicateFiles([]);
        }}
        size="lg"
        dialogClassName="modal-top"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DocumentUploadForm
            files={uploadFiles}
            onFilesChange={setUploadFiles}
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
            categories={documentClassifications}
            dynamicFields={dynamicFields}
            onDynamicFieldsChange={setDynamicFields}
            isPrivate={isPrivate}
            onIsPrivateChange={setIsPrivate}
            selectedBranches={selectedBranches}
            onBranchesChange={handleBranchChange}
            selectedDepartments={selectedDepartments}
            onDepartmentsChange={handleDepartmentChange}
            selectedSubDepartments={selectedSubDepartments}
            onSubDepartmentsChange={handleSubDepartmentChange}
            branches={branches}
            departments={departments}
            subDepartments={subDepartments}
            filteredDepartments={filteredDepartments}
            filteredSubDepartments={filteredSubDepartments}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button className="doc-form-cancel-btn" onClick={() => {
            setShowUploadModal(false);
            setUploadFiles([]);
            setSelectedCategory(null);
            setDynamicFields({});
            setIsPrivate(false);
            setSelectedBranches([]);
            setSelectedDepartments([]);
            setSelectedSubDepartments([]);
            setFilteredDepartments(departments);
            setFilteredSubDepartments(subDepartments);
            setDuplicateFiles([]);
          }}>
            Cancel
          </Button>
          <Button
            className="doc-form-submit-btn"
            onClick={handleFileUpload}
            disabled={uploadFiles.length === 0}
          >
            Upload
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Duplicate Files Modal */}
      <Modal
        show={showDuplicateModal}
        onHide={() => {
          setShowDuplicateModal(false);
          setDuplicateFiles([]);
          setDuplicateChoices({});
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Duplicate Files Found</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            The following files already exist. Choose an action for each file:
          </p>
          {duplicateFiles.map((dup, index) => (
            <div key={index} className="mb-3 p-3" style={{ border: '1px solid #e9ecef', borderRadius: '6px', backgroundColor: '#f8f9fa' }}>
              <div className="mb-2">
                <strong>{dup.file.name}</strong>
                {dup.duplicateData && (
                  <small className="text-muted d-block mt-1">
                    Existing file found in: {dup.duplicateData.location || 'Unknown location'}
                  </small>
                )}
              </div>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  id={`replace-${index}`}
                  name={`duplicate-choice-${index}`}
                  label="Replace existing file"
                  checked={duplicateChoices[dup.file.name] === 'replace'}
                  onChange={() => {
                    setDuplicateChoices({
                      ...duplicateChoices,
                      [dup.file.name]: 'replace'
                    });
                  }}
                />
                <Form.Check
                  type="radio"
                  id={`copy-${index}`}
                  name={`duplicate-choice-${index}`}
                  label="Keep as copy (rename)"
                  checked={duplicateChoices[dup.file.name] === 'copy'}
                  onChange={() => {
                    setDuplicateChoices({
                      ...duplicateChoices,
                      [dup.file.name]: 'copy'
                    });
                  }}
                />
              </div>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="doc-form-cancel-btn"
            onClick={() => {
              setShowDuplicateModal(false);
              setDuplicateFiles([]);
              setDuplicateChoices({});
            }}
          >
            Cancel
          </Button>
          <Button
            className="doc-form-submit-btn"
            onClick={() => {
              proceedWithUpload(uploadFiles, duplicateChoices);
            }}
          >
            Continue Upload
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Create Document Classification Modal */}
      <Modal show={showFolderModal} onHide={() => {
        setShowFolderModal(false);
        setClassificationFormData({
          name: '',
          parent_id: null,
          fields: [createField()]
        });
        setClassificationFormErrors({});
        setPrefillParentId(null);
      }} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Create New Document Classification</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Document Classification Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter document classification name"
                    value={classificationFormData.name}
                    onChange={(e) => handleClassificationFormChange(e, null, "classification")}
                  />
                  {classificationFormErrors.name && (
                    <div className="text-danger" style={{ marginTop: '0.25rem', fontSize: '0.875rem' }}>
                      {classificationFormErrors.name}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Parent Classification (Optional)</Form.Label>
                  <Form.Select
                    value={classificationFormData.parent_id || ""}
                    onChange={(e) => handleClassificationFormChange(e, null, "parent_id")}
                    disabled={loadingClassificationsForParent}
                    style={{ height: '50px' }}
                    className="form-control"
                  >
                    <option value="">None (Top Level Classification)</option>
                    {availableClassificationsForParent.map(cat => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Select>
                  {classificationFormData.parent_id && (
                    <small className="text-muted" style={{ marginTop: '0.25rem', display: 'block' }}>
                      This classification will be created as a sub-classification
                    </small>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Fields</h6>
              <Button
                variant="success"
                size="sm"
                onClick={addClassificationField}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <FiPlus style={{ marginRight: '0.25rem' }} /> Add Field
              </Button>
            </div>

            {classificationFormData.fields.map((field, index) => (
              <div
                key={field.id || index}
                className="mb-3 p-3"
                style={{ backgroundColor: '#f8f9fa', borderRadius: '0.375rem', border: '1px solid #dee2e6' }}
              >
                <Row>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>
                        Field Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter field name"
                        value={field.fieldName}
                        onChange={(e) => handleClassificationFormChange(e, index, "fieldName")}
                      />
                      {classificationFormErrors[`fieldName_${index}`] && (
                        <div className="text-danger" style={{ marginTop: '0.25rem', fontSize: '0.875rem' }}>
                          {classificationFormErrors[`fieldName_${index}`]}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>
                        Field Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={field.fieldType}
                        onChange={(e) => handleClassificationFormChange(e, index, "fieldType")}
                        style={{ height: '50px' }}
                        className="form-control"
                      >
                        {FIELD_TYPES.map(type => (
                          <option key={type.value} value={type.value}>{type.label}</option>
                        ))}
                      </Form.Select>
                      {classificationFormErrors[`fieldType_${index}`] && (
                        <div className="text-danger" style={{ marginTop: '0.25rem', fontSize: '0.875rem' }}>
                          {classificationFormErrors[`fieldType_${index}`]}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => deleteClassificationField(index)}
                      title="Delete field"
                    >
                      <FiTrash2 />
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="doc-form-cancel-btn"
            onClick={() => {
              setShowFolderModal(false);
              setClassificationFormData({
                name: '',
                parent_id: null,
                fields: [createField()]
              });
              setClassificationFormErrors({});
            }}
          >
            Cancel
          </Button>
          <Button
            className="doc-form-submit-btn"
            onClick={handleCreateClassification}
            disabled={loading || !classificationFormData.name.trim()}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Creating...
              </>
            ) : (
              'Create Classification'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Share Document Modal */}
      <ShareDocumentModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        fileId={shareSelectedItem?.id}
        selectedBranches={shareSelectedBranches}
        onBranchesChange={handleShareBranchChange}
        selectedDepartments={shareSelectedDepartments}
        onDepartmentsChange={handleShareDepartmentChange}
        selectedSubDepartments={shareSelectedSubDepartments}
        onSubDepartmentsChange={handleShareSubDepartmentChange}
        branches={branches}
        departments={departments}
        subDepartments={subDepartments}
        filteredDepartments={shareFilteredDepartments}
        filteredSubDepartments={shareFilteredSubDepartments}
        availableUsers={shareFilteredUsers}
        selectedUsers={shareSelectedUsers}
        onUsersChange={handleShareUserChange}
        onInternalShare={handleShareDocument}
        onEmailShare={handleEmailShareDocument}
        sharing={sharing}
        onReset={resetShareForm}
      />

      <InternalFooter />
    </div>
  );
};

export default DocumentsDashboard;

